export default "__VITE_ASSET__e12b7143__"